import "./src/styles/global.css";
import React from "react";
import Provider from "./src/components/hoc/context/product/provider";

export const wrapRootElement = ({ element }: any) => {
	return (
		<Provider>{element}</Provider>
	)
}